import React from "react";
import { SectionGrid, SummaryGrid } from "../AdminAnalyticsCards";
import CssBarChart from "../charts/CssBarChart";
import AdminAnalyticsTable, { UserCell } from "../tables/AdminAnalyticsTable";
import { aa, formatDay, formatLabel, formatNumber, getUserLabel, getUserSubLabel } from "../adminAnalyticsUtils";
function formatSocialActivitySublabel(friendRequests, messages) {
  return aa("social_activity_sublabel", "{{friendRequests}} friend requests, {{messages}} messages", {
    friendRequests: formatNumber(friendRequests),
    messages: formatNumber(messages),
  });
}
export default function AdminAnalyticsSocialTab({
  data
}) {
  const summary = data?.summary || {};
  return <>
      <SummaryGrid cards={[{
      label: aa("follows", "Follows"),
      value: formatNumber(summary.follows)
    }, {
      label: aa("friendships", "Friendships"),
      value: formatNumber(summary.friendships)
    }, {
      label: aa("friend_requests", "Friend requests"),
      value: formatNumber(summary.friendRequests)
    }, {
      label: aa("pending_friend_requests", "Pending friend requests"),
      value: formatNumber(summary.pendingFriendRequests)
    }, {
      label: aa("groups", "Groups"),
      value: formatNumber(summary.groups)
    }, {
      label: aa("group_members", "Group members"),
      value: formatNumber(summary.groupMembers)
    }, {
      label: aa("group_posts", "Group posts"),
      value: formatNumber(summary.groupPosts)
    }, {
      label: aa("group_comments", "Group comments"),
      value: formatNumber(summary.groupComments)
    }, {
      label: aa("messages", "Messages"),
      value: formatNumber(summary.messages)
    }]} />


      <SectionGrid>
        <CssBarChart title={aa("social_activity_by_day", "Social activity by day")} rows={data?.socialActivityByDay} getLabel={row => formatDay(row?.day)} getValue={row => Number(row?.follows || 0) + Number(row?.friendRequests || 0) + Number(row?.messages || 0) + Number(row?.groupPosts || 0)} getSublabel={row => formatSocialActivitySublabel(row?.friendRequests, row?.messages)} />

        <CssBarChart title={aa("friend_requests_by_status", "Friend requests by status")} rows={data?.friendRequestsByStatus} getLabel={row => formatLabel(row?.status)} getValue={row => row?.count} />

        <CssBarChart title={aa("group_join_requests", "Group join requests")} rows={data?.groupJoinRequestsByStatus} getLabel={row => formatLabel(row?.status)} getValue={row => row?.count} />

        <CssBarChart title={aa("group_invites", "Group invites")} rows={data?.groupInvitesByStatus} getLabel={row => formatLabel(row?.status)} getValue={row => row?.count} />

        <CssBarChart title={aa("groups_by_type_and_visibility", "Groups by type and visibility")} rows={data?.groupsByTypeVisibility} getLabel={row => `${formatLabel(row?.groupType)} / ${formatLabel(row?.visibility)}`} getValue={row => row?.count} />

        <AdminAnalyticsTable title={aa("top_social_users", "Top social users")} rows={data?.topSocialUsers} rowKey={row => getUserSubLabel(row)} columns={[{
        header: aa("user", "User"),
        render: row => <UserCell title={getUserLabel(row)} subtitle={getUserSubLabel(row)} />
      }, {
        header: aa("actions", "Actions"),
        render: row => formatNumber(row?.actions)
      }]} />

      </SectionGrid>
    </>;
}
